export const models = {
  state: {},
  reducers: {},
  effects: (dispatch) => ({}),
};
